import { createForm, createPrimitiveField, type InferFormValue } from '@adv-frontend/form-kit';
import {
    factoryGetErrorMessage,
    VALUE_IS_REQUIRED_CODE,
    VALUE_IS_REQUIRED_MESSAGE,
    type ValueIsRequiredValidationError,
} from '#shared/lib/form';
import { GSC_CONNECTION_METHOD, type GscConnectionMethod } from './constants';

interface GscConnectionFormContext {
    onVerificationCodeSubmit: (verificationCode: string) => Promise<boolean>;
}

export const gscConnectionFormGetErrorMessage = factoryGetErrorMessage<ValueIsRequiredValidationError>({
    [VALUE_IS_REQUIRED_CODE]: VALUE_IS_REQUIRED_MESSAGE,
});

export const gscConnectionForm = createForm({
    name: 'GscConnectionForm',
    context: (context: GscConnectionFormContext) => {
        return { form: context };
    },
    fields: {
        method: createPrimitiveField({
            defaultValue: GSC_CONNECTION_METHOD.AUTOMATIC as GscConnectionMethod,
        }),
        verificationCode: createPrimitiveField({
            defaultValue: '',
            validators: (createValidators) =>
                createValidators<ValueIsRequiredValidationError>({
                    onSubmit: [],
                }),
        }),
    },
    validators: (createValidators) =>
        createValidators<ValueIsRequiredValidationError>({
            onSubmit: [
                (value, formApi) => {
                    if (value.method === GSC_CONNECTION_METHOD.VERIFICATION_CODE && !value.verificationCode.trim()) {
                        formApi.fields.verificationCode.addValidationError({
                            code: VALUE_IS_REQUIRED_CODE,
                        });
                    }
                },
            ],
        }),
    onSubmit: async (values, formApi) => {
        const { onVerificationCodeSubmit } = formApi.getContext();

        if (values.method === GSC_CONNECTION_METHOD.AUTOMATIC) {
            return false;
        }

        return onVerificationCodeSubmit(values.verificationCode.trim());
    },
});

export type GscConnectionFormValues = InferFormValue<typeof gscConnectionForm>;
